import {getCalendarMonth} from '../helpers/calendarHelper'
import axios from 'axios'
import moment from 'moment'
import { I18n } from 'react-redux-i18n'

import {history} from "../helpers/history"

import {getUrlPrefix, getHeaders} from "../helpers/urlHelper"

export function setFirstDate(date){
  return function(dispatch) {
    // Set date
    dispatch({type: "SET_DATE", payload: date})

    getByMonth(dispatch, date)
  }
}

export function setDate(date, oldDate) {
  return function(dispatch) {
    // Check if date is in same month or generate new weeks
    if(!date.isSame(oldDate, 'month')){
      getByMonth(dispatch, date)
    }

    history.push(`/month/${date.format('YYYYMMDD')}`)

    // Set date
    dispatch({type: "SET_DATE", payload: date.clone()})
  }
}

export function setWeeks(weeks) {
  return {type: "SET_WEEKS", payload: weeks}
}

export function nextMonth(date){
  return function(dispatch) {
    const newDate = date.clone().add(1, 'months')
    getByMonth(dispatch, newDate)

    // Set date
    dispatch({type: "SET_DATE", payload: newDate})

    history.push(`/month/${newDate.format('YYYYMMDD')}`)
  }
}

export function previousMonth(date){
  return function(dispatch) {
    const newDate = date.clone().add(-1, 'months')
    getByMonth(dispatch, newDate)

    // Set date
    dispatch({type: "SET_DATE", payload: newDate})

    history.push(`/month/${newDate.format('YYYYMMDD')}`)
  }
}

function getByMonth(dispatch, date){
  if(date === null) return

  dispatch({type: "SET_WEEKS", payload: getCalendarMonth(date)})

  // Get appointments from new month when in future
  if(date.diff(moment().startOf('month')) >= 0){
    dispatch({type: "APPOINTMENT_FETCH_MONTH"})

    axios.get(getUrlPrefix() + "/afspraken/maand/"+date.format('YYYYMMDD'), {
        headers: getHeaders()
      })
      .then((response) => {
        dispatch({type: "APPOINTMENT_FETCH_MONTH_FULFILLED", payload: response.data.afspraken})
      })
      .catch((err) => {
        dispatch({type: "APPOINTMENT_FETCH_MONTH_REJECTED", payload: err})

        // Show error snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'error',
          message: I18n.t('global.server_error'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 5000
        }})
      })
  }
}



// WEBPACK FOOTER //
// ./src/js/actions/calendarActions.js